import type { AnnouncementLevel } from 'shared'

/** Text and background chosen together for contrast, in both themes. */
export const LEVEL_CLASSES: Record<AnnouncementLevel, string> = {
  info: 'bg-primary-700 text-white dark:bg-primary-800',
  success: 'bg-emerald-700 text-white dark:bg-emerald-800',
  warning: 'bg-amber-300 text-amber-950 dark:bg-amber-400',
  critical: 'bg-red-700 text-white dark:bg-red-800',
}
